"use strict";

exports.__esModule = true;
exports.NavbarSettingsMenuContext = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var NavbarSettingsMenuContext = exports.NavbarSettingsMenuContext = /*#__PURE__*/_react["default"].createContext({});